module.exports = __webpack_public_path__ + "static/media/fresh-green.79d6aa90.png";